import { DetailExpertise } from '@components'

export const ExpertiseDetail = () => {
    return (
        <>
            <DetailExpertise />
            {/* <ShouldLike /> */}
        </>
    )
}
